import { dpiAlertNotification } from "@/features/modules/dpiAlert/notification/dpiAlertNotification";

export const featuresNotificationModules = [dpiAlertNotification];
